// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pdf-app-loading[data-v-f7102760]{position:absolute;width:100%;height:100%;background:hsla(0,0%,60%,.5);left:0;top:0;z-index:999999;display:flex;align-items:center;justify-content:center}.pdf-app-loading .txt-message[data-v-f7102760]{position:absolute;top:570px;bottom:0;color:var(--primary-color-text)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
